import { useTranslate } from '@va/localization';
import { TextInput } from '@va/ui/design-system';
import { EmailFormFieldNames, useChangeEmailForm } from './useChangeEmailForm';

export const CHANGE_EMAIL_FORM_ID = 'change-email-form';

type ChangeEmailFormProps = {
  form: ReturnType<typeof useChangeEmailForm>;
};

const ChangeEmailForm = ({
  form: { handleSubmit, handleChange, handleBlur, values, errors, touched, setFieldValue },
}: ChangeEmailFormProps) => {
  const translate = useTranslate();

  return (
    <form id={CHANGE_EMAIL_FORM_ID} name='change-email' onSubmit={handleSubmit}>
      <div className='change-email-content p-4 md:p-8'>
        <TextInput
          name={EmailFormFieldNames.Email}
          placeholder={translate('register.form.email.placeholder')}
          onChange={handleChange}
          onBlur={handleBlur}
          clearField={() => setFieldValue(EmailFormFieldNames.Email, '')}
          value={values[EmailFormFieldNames.Email] ?? undefined}
          error={errors.email && touched.email ? translate(errors.email) : undefined}
          autoFocus
        />
      </div>
    </form>
  );
};

export default ChangeEmailForm;
